import React from 'react';
import Career from './Career';
import Footer from '../footer/footer';

const CareerPage = () => (
  <>
    <Career />
    <Footer />
  </>
);

export default CareerPage;
